var _a;
import { COMMIT_TYPE } from "./types/commitType";
import { isNullOrUndefined } from "../../../../FastFailureFeedback.Web.Common/Typescript/utils/functions";
import { MachineRegistrationData } from "../../Common/types/internal/machineRegistrationBase";
export var mutations = (_a = {},
    _a[COMMIT_TYPE.Initializing] = function (state, value) {
        state.isInitializing = value;
    },
    _a[COMMIT_TYPE.InitializationData] = function (state, value) {
        state.initializationData = value;
    },
    _a[COMMIT_TYPE.ValidationCollector] = function (state, value) {
        state.validationCollector = value;
    },
    _a[COMMIT_TYPE.IsLoadingMachineInformation] = function (state, value) {
        state.isLoadingMachineInformation = value;
    },
    _a[COMMIT_TYPE.MachineInformation] = function (state, value) {
        state.registration.machineInformation = value;
        state.registration.machineRegistrationData.machineModel = value.unitDescription;
    },
    _a[COMMIT_TYPE.IsCreating] = function (state, value) {
        state.isCreating = value;
    },
    _a[COMMIT_TYPE.IsAdding] = function (state, value) {
        state.isAdding = value;
    },
    _a[COMMIT_TYPE.PartialSubmit] = function (state, value) {
        if (isNullOrUndefined(value))
            state.newAttachmentId = null;
        state.newAttachmentId = value;
    },
    _a[COMMIT_TYPE.Registration] = function (state, value) {
        state.registration = value;
    },
    _a[COMMIT_TYPE.MachineRegistrationData] = function (state, machineRegistration) {
        var _a, _b;
        var newMachineRegistration = new MachineRegistrationData();
        machineRegistration.tempAttachmentId = (_a = state.newAttachmentId) !== null && _a !== void 0 ? _a : null;
        (_b = state.registration) === null || _b === void 0 ? void 0 : _b.machineRegistrations.push(machineRegistration);
        newMachineRegistration.nonce = state.registration.nonce;
        state.registration.machineRegistrationData = newMachineRegistration;
        state.registration.attachments = [];
    },
    _a[COMMIT_TYPE.SetErrors] = function (state, value) {
        if (state.errors == null) {
            state.errors = value;
        }
        else {
            state.errors = value;
        }
    },
    _a[COMMIT_TYPE.ResetErrors] = function (state, value) {
        state.errors = [];
    },
    _a);
